import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Home from "./components/Home";
import MainSearchForm from "./components/MainSearchForm";
import SideNav from "./components/SideNav";
import AboutAppBtn from "./components/AboutAppBtn";
import LoadingStatusModal from "./components/LoadingStatusModal";
import AboutModal from "./components/AboutModal";

import explorer_logo from "./explorer_logo.png";
import heart_outline from "./heart_outline.svg";
import heart from "./heart.svg";
//import info from "./info.svg";

import axios from "axios";
import _ from "lodash";
import moment from "moment";
//import { sortBy } from "lodash";
import {
  Navbar,
  Progress,
  Nav,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      searchTerm: "Glastonbury",
      allJobsData: [],
      favItems: [],
      items: [],
      roleValue: "",
      searchInResults: "",
      locationValue: "",
      daysValue: "1",
      sortByValue: "salary_high",
      loadingText: "",
      countText: 0,
      permJobsCount: 0,
      contractJobsCount: 0,
      undefinedJobsCount: 0,
      contractTypesNumbers: {},
      isOlderstFirst: true,
      isLowestFirst: true,
      salarySortLinkText: "High to Low",
      dateSortLinkText: "New to Old",
      modal: false,
      nrOfResultPages: 0,
      isLoading: false,
      contractChecked: true,
      permChecked: true,
      undefinedChecked: true,
      currentpageLoaded: 0,
      noSearchDone: true,
      selectedOptionId: 0,
      contractCheckBoxDisabled: true,
      permanentCheckBoxDisabled: true,
      undefinedCheckBoxDisabled: true,

      keywordClrBtnDisabled: true,
      aboutmodal: false,
      filters: {
        //contract_type: [undefined, "contract", "permanent"]
        contract_type: []
      },
      jobtypesArr: []
    };

    //this.jobSearch = this.jobSearch.bind(this);
    this.addHeartClicked = this.addHeartClicked.bind(this);
    this.addToFavourites = this.addToFavourites.bind(this);
    this.toggle = this.toggle.bind(this);
    this.abouttoggle = this.abouttoggle.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleSearchInResults = this.handleSearchInResults.bind(this);
    this.loadAllAdzunaResults = this.loadAllAdzunaResults.bind(this);
    this.handleDaysChange = this.handleDaysChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClearPressed = this.handleClearPressed.bind(this);
    this.handleSortByTypeChange = this.handleSortByTypeChange.bind(this);

    this.handleSort = this.handleSort.bind(this);
    this.parseItems = this.parseItems.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.selectSortBy = this.selectSortBy.bind(this);
  }

  handleCheckBoxChange(e) {
    let currentFilterArr = this.state.filters;
    let that = this;
    const itemName = e.target.name;
    const isChecked = e.target.checked;
    //alert("Check change:! " + e.target.name + " isChecked is: " + isChecked);
    let checkboxValue;

    if (isChecked) {
      currentFilterArr.contract_type.push(itemName);
      checkboxValue = true;
    } else {
      let arrNR = currentFilterArr.contract_type.findIndex(k => k == itemName);
      currentFilterArr.contract_type.splice(arrNR, 1);
      checkboxValue = false;
    }

    if (e.target.name === "contract") {
      that.setState(
        { contractChecked: checkboxValue, filters: currentFilterArr },
        function() {
          console.log(
            "this.state.filters: " + JSON.stringify(that.state.filters)
          );
        }
      );
    } else if (e.target.name === "permanent") {
      that.setState(
        { permChecked: checkboxValue, filters: currentFilterArr },
        function() {
          console.log(
            "this.state.filters: " + JSON.stringify(that.state.filters)
          );
        }
      );
    } else if (e.target.name === "undefined") {
      that.setState(
        { undefinedChecked: checkboxValue, filters: currentFilterArr },
        function() {
          console.log(
            "this.state.filters: " + JSON.stringify(that.state.filters)
          );
        }
      );
    }
    //console.log("this.state.filters: " + this.state.filters);
    //console.log("this.state.filters: " + JSON.stringify(this.state.filters));
  }

  parseItems() {
    //alert("ParseItems Called");

    const contractTypesARR = this.state.items.map(x => x.contract_type);
    let contractTypesNumbers = contractTypesARR.reduce(function(acc, curr) {
      if (typeof acc[curr] == "undefined") {
        acc[curr] = 1;
      } else {
        acc[curr] += 1;
      }

      return acc;
    }, {});

    //get only the keys: undefined, permanent, contract in current items list
    let contractTypesKeysOnly = [];
    for (var k in contractTypesNumbers) contractTypesKeysOnly.push(k);

    //seState for to be used for number of each contract
    this.setState({ contractTypesNumbers: contractTypesNumbers });

    this.setState(prevState => ({
      filters: {
        // object that we want to update
        ...prevState.filters, // keep all other key-value pairs
        contract_type: contractTypesKeysOnly // update the value of specific key
      }
    }));

    //const uniqueJobTypes = jobtypes.unique();
    //SimpChars.map(x => x.surname);
    console.log("PARSE RESULT: =========");
    console.log("RESULT: =========");
    console.log("RESULT: =========");
    console.log("contractTypesNumbers" + JSON.stringify(contractTypesNumbers));
    console.log(
      "contractTypesKeysOnly" + JSON.stringify(contractTypesKeysOnly)
    );
    console.log("this.state.filters" + JSON.stringify(this.state.filters));

    //update job types checkboxes
    let containsContracts = contractTypesKeysOnly.includes("contract");
    this.setState({ contractCheckBoxDisabled: !containsContracts });
    let containsPermanent = contractTypesKeysOnly.includes("permanent");
    this.setState({ permanentCheckBoxDisabled: !containsPermanent });
    let containsUndefined = contractTypesKeysOnly.includes("undefined");
    this.setState({ undefinedCheckBoxDisabled: !containsUndefined });

    console.log("contractTypesKeysOnly contains contract:" + containsContracts);
    console.log(
      "contractTypesKeysOnly contains permanent:" + containsPermanent
    );
    console.log(
      "contractTypesKeysOnly contains undefined:" + containsUndefined
    );

    //this.sortBy("salary_max");

    //this.addFavValues();
    this.setState({ sortByValue: "salary_high" });
    this.selectSortBy("salary_max");
    this.addUndefinedValues();
  }

  addToFavourites(theitem, theval) {
    // the heart value is true add it to favItems
    if (theval) {
      this.setState({ favItems: this.state.favItems.concat(theitem) });
    } else {
      // delete from favItems
      this.setState(state => {
        const favItems = state.favItems.filter(item => item.id !== theitem.id);

        return {
          favItems
        };
      });
    }

    console.log("ACTION TO TAKE: " + theval);
    console.log("THE ITEM: " + theitem);
  }

  addHeartClicked(event, itemId) {
    event.preventDefault();
    //alert("YO");
    console.log("HI!");
    console.log(itemId);
    let theval;
    let clickedItem;
    this.setState(
      state => {
        const items = state.items.map(item => {
          if (itemId === item.id) {
            // Ad/Remove to FavItems[]

            theval = !item.favAdded;
            clickedItem = item;

            return { ...item, favAdded: theval };
          } else {
            return item;
          }
        });

        return {
          items
        };
      },
      () => this.addToFavourites(clickedItem, theval)
    );
  }

  addUndefinedValues() {
    console.log("Add THE Undefined Values!!!!" + this.state.items.length);

    for (let i = 0; i < this.state.items.length; i++) {
      // CHECK HERE IF THIS ITEM IS ALREADY IN favItems if it is set to true

      if (this.state.items[i].contract_type == undefined) {
        console.log(
          "FOUND AN UNDEFINED ITEM,  TITLE IS: " + this.state.items[i].title
        );
        this.state.items[i].contract_type = "undefined";
      } else {
        //do nothing
        //this.state.items[i].favAdded = false;
      }
    }

    // Now AddFavValues
    console.log("THERE SHOULD BE UNDEFINED VALUES NOW!!!");
    console.log("++++++++++++++++++");
    console.log(this.state.items);
    this.addFavValues();
  }

  addFavValues() {
    console.log("ADd THE HEART!!!!" + this.state.items.length);

    for (let i = 0; i < this.state.items.length; i++) {
      // CHECK HERE IF THIS ITEM IS ALREADY IN favItems if it is set to true

      if (this.state.favItems.some(e => e.id === this.state.items[i].id)) {
        console.log("FOUND IT!!!!!! TITLE IS: " + this.state.items[i].title);
        this.state.items[i].favAdded = true;
      } else {
        this.state.items[i].favAdded = false;
      }
    }

    //console.log(this.state.items);
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  abouttoggle() {
    this.setState(prevState => ({
      aboutmodal: !prevState.aboutmodal
    }));
  }

  clearSearch() {
    this.setState({
      noSearchDone: true,
      roleValue: "",
      searchInResults: "",
      locationValue: "",
      daysValue: "1",
      sortByValue: "salary_high",
      selectedOptionId: 0,
      allJobsData: [],
      items: []
    });
  }

  handleRoleChange(event) {
    this.setState({ roleValue: event.target.value });
  }

  handleSearchInResults(event) {
    this.setState({ searchInResults: event.target.value });
    if (event.target.value.length > 0) {
      this.setState({ keywordClrBtnDisabled: false });
    } else {
      this.setState({ keywordClrBtnDisabled: true });
    }
  }

  handleLocationChange(event) {
    this.setState({ locationValue: event.target.value });
  }

  handleDaysChange(event) {
    this.setState({ daysValue: event.target.value });
    console.log("DAYS CHANGED, Value = " + event.target.value);
  }

  handleSortByTypeChange(event) {
    this.setState({ sortByValue: event.target.value });
    console.log("Sort Type Changed to Value = " + event.target.value);
    this.selectSortBy(event.target.value);
  }

  selectSortBy(field) {
    if (field == "date_old") {
      this.setState({
        items: _.sortBy(this.state.items, "created")
      });
    } else if (field == "date_new") {
      this.setState({
        items: _.sortBy(this.state.items, "created").reverse()
      });
    } else if (field == "salary_low") {
      this.setState({
        items: _.sortBy(this.state.items, "salary_max")
      });
    } else if (field == "salary_high") {
      this.setState({
        items: _.sortBy(this.state.items, "salary_max").reverse()
      });
    }
  }

  sortBy(field) {
    if (field == "created") {
      if (this.state.isOlderstFirst) {
        this.setState({
          items: _.sortBy(this.state.items, field),
          dateSortLinkText: "Old to New"
        });
      } else {
        this.setState({
          items: _.sortBy(this.state.items, field).reverse(),
          dateSortLinkText: "New to Old"
        });
      }

      this.setState({
        isOlderstFirst: !this.state.isOlderstFirst
      });
      //
    } else if (field == "salary_max") {
      if (this.state.isLowestFirst) {
        this.setState({
          items: _.sortBy(this.state.items, field),
          salarySortLinkText: "Low to High"
        });
      } else {
        this.setState({
          items: _.sortBy(this.state.items, field).reverse(),
          salarySortLinkText: "High to Low"
        });
      }

      this.setState({
        isLowestFirst: !this.state.isLowestFirst
      });
    }
  }

  handleSort(event) {
    const { items } = this.state;
    let newItemsList = items.reverse();

    this.setState({
      items: _.sortBy(this.state.items, this.state.items.salary_max)
    });
  }

  compareDate(dateToCompare) {
    let returnString = "";

    var given = moment(dateToCompare, "YYYY-MM-DD");
    var current = moment().startOf("day");

    //Difference in number of days
    let daysDiff = Math.abs(moment.duration(given.diff(current)).asDays());

    if (daysDiff == 0) {
      returnString = "Today";
    } else if (daysDiff == 1) {
      returnString = "1 Day ago";
    } else {
      returnString = daysDiff.toString() + " Days ago";
    }

    return returnString;
  }

  loadAllAdzunaResults() {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    let nrOfPages = this.state.nrOfResultPages;
    //alert("this.state.nrOfResultPages: " + this.state.nrOfResultPages);

    console.log("nrOfPages: " + nrOfPages);
    var that = this;
    let index = 2;
    function request() {
      return axios
        .get(
          "https://api.adzuna.com/v1/api/jobs/gb/search/" +
            index +
            "?app_id=8351eeae&app_key=471dd352d24e6372bb112f7148ece2ba&results_per_page=50&what=" +
            that.state.roleValue +
            "&where=" +
            that.state.locationValue +
            "&sort_by=salary&full_time=1&max_days_old=" +
            that.state.daysValue +
            "&content-type=application/json",
          {
            cancelToken: source.token
          }
        )
        .catch(function(thrown) {
          if (axios.isCancel(thrown)) {
            console.log("Request canceled", thrown.message);
          } else {
            // handle error
          }
        })
        .then(res => {
          let tempData = res.data.results;

          //this.setState({ items: tempData.results });
          that.setState({ items: that.state.items.concat(tempData) });
          console.log("=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+=+");

          console.log("Tempdata.length: " + tempData.length);
          console.log("Tempdata: " + JSON.stringify(tempData));
          that.parseItems();
          //console.log("that.state.items: " + that.state.items.value);
          //console.log("that.state.items.length IS: " + that.state.items.length);
          index++;

          that.setState({ currentpageLoaded: index });
          //console.log("LOADED PAGE NR: " + index);
          if (index > nrOfPages) {
            console.log("STOOOOOOOOOOOOOOP!!!!");
            that.setState({ modal: false });
            return "done";
          }

          return request();
        });
    }

    that.setState({ isLoading: false });
    return request();
  }

  handleClearPressed() {
    this.setState({ searchInResults: "", keywordClrBtnDisabled: true });
  }

  handleSubmit(event) {
    this.setState({
      items: [],
      loadingText: "SEARCHING...",
      isLoading: true,
      noSearchDone: false,
      countText: 0,
      contractChecked: true,
      permChecked: true,
      undefinedChecked: true
    });

    event.preventDefault();
    axios
      .get(
        "https://api.adzuna.com/v1/api/jobs/gb/search/1?app_id=8351eeae&app_key=471dd352d24e6372bb112f7148ece2ba&results_per_page=50&what=" +
          this.state.roleValue +
          "&where=" +
          this.state.locationValue +
          "&sort_by=salary&full_time=1&max_days_old=" +
          this.state.daysValue +
          "&content-type=application/json"
      )
      .then(res => {
        const allJobsData = res.data;
        this.setState({ allJobsData });

        this.setState({ loadingText: "" });
        this.setState({ countText: allJobsData.count });

        this.setState({ items: allJobsData.results });
        this.parseItems();

        //LAUNCH MODAL IF MORE RESULTS TO LOAD
        if (allJobsData.count > 50) {
          this.setState({ isLoading: true });
          let nrOfResultPages = Math.ceil(allJobsData.count / 50);
          console.log("nrOfResultPages = " + nrOfResultPages);
          this.setState({ modal: true, nrOfResultPages: nrOfResultPages });
          this.loadAllAdzunaResults();
        } else {
          this.setState({ isLoading: false });
        }
      });
    //loadCityData
  }
  renderGroup(group) {
    switch (group) {
      case "contract":
        return "jobTypeBG-Yellow";
      case "permanent":
        return "jobTypeBG-Orange";
      default:
        return "jobTypeBG-Undefined";
    }
  }

  multiFilter(array, filters) {
    const filterKeys = Object.keys(filters);
    // filters all elements passing the criteria
    return array.filter(item => {
      // dynamically validate all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        return filters[key].includes(item[key]);
      });
    });
  }

  // {this.renderGroup(this.state.shownGroup)}

  componentDidMount() {}

  render() {
    let filtered = this.multiFilter(this.state.items, this.state.filters);
    let numberOfContractTypes = this.state.filters.contract_type.length;
    console.log(
      "numberOfContractTypes for this search is = " + numberOfContractTypes
    );

    const ColoredLine = ({ color }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          height: 2
        }}
      />
    );
    // NB BELOW:
    let filteredJobs = filtered.filter(item => {
      //let filteredJobs = this.state.items.filter(item => {
      //return item.title.indexOf(this.state.searchInResults) !== -1; //filter on title
      return item.description.indexOf(this.state.searchInResults) !== -1; //filter on description
    });

    const numFilteredJobs = filteredJobs.length;

    return (
      <BrowserRouter>
        <div className="App">
          <Navbar className="mainNav" sticky={"top"}>
            <Row>
              <Col sm="3">
                <img
                  src={explorer_logo}
                  className="App-logo2"
                  alt="logo"
                  onClick={this.clearSearch}
                />
              </Col>
              <Col sm="7">
                <Row form>
                  <MainSearchForm
                    roleValue={this.state.roleValue}
                    onRoleChange={this.handleRoleChange}
                    locationValue={this.state.locationValue}
                    handleLocationChange={this.handleLocationChange}
                    selectedOptionId={this.state.selectedOptionId}
                    onSubmit={this.handleSubmit}
                    daysValue={this.state.daysValue}
                    handleDaysChange={this.handleDaysChange}
                  />
                </Row>
              </Col>
              <Col sm="2">
                <Row>
                  <Col xs="6">
                    <AboutAppBtn abouttoggle={this.abouttoggle} />
                  </Col>
                  <Col xs="6">
                    <div className="info-Holder">
                      <span className="from-label">SAVED</span>
                      <span className="favItemsCounter">
                        {this.state.favItems.length}
                      </span>
                      <img src={heart} alt="logo" />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Navbar>

          <Home noSearchDone={this.state.noSearchDone} />
          {this.state.isLoading ? (
            <div className="spinner-Holder">
              <Spinner color="primary" />
            </div>
          ) : (
            <div>
              <Row>
                <Col xs="3">
                  <SideNav
                    loadingText={this.state.loadingText}
                    countText={this.state.countText}
                    contractChecked={this.state.contractChecked}
                    handleCheckBoxChange={this.handleCheckBoxChange}
                    contractTypesNumbers_contract={
                      this.state.contractTypesNumbers.contract
                    }
                    permChecked={this.state.permChecked}
                    contractTypesNumbers_permanent={
                      this.state.contractTypesNumbers.permanent
                    }
                    undefinedChecked={this.state.undefinedChecked}
                    contractTypesNumbers_undefined={
                      this.state.contractTypesNumbers.undefined
                    }
                    searchInResults={this.state.searchInResults}
                    handleSearchInResults={this.handleSearchInResults}
                    sortByCreated={this.sortBy.bind(this, "created")}
                    dateSortLinkText={this.state.dateSortLinkText}
                    sortBySalary={this.sortBy.bind(this, "salary_max")}
                    salarySortLinkText={this.state.salarySortLinkText}
                    numFilteredJobs={numFilteredJobs}
                    coloredLine={<ColoredLine color="#adb5bd" />}
                    contractCheckBoxDisabled={
                      this.state.contractCheckBoxDisabled
                    }
                    permanentCheckBoxDisabled={
                      this.state.permanentCheckBoxDisabled
                    }
                    undefinedCheckBoxDisabled={
                      this.state.undefinedCheckBoxDisabled
                    }
                    keywordClrBtnDisabled={this.state.keywordClrBtnDisabled}
                    noSearchDone={this.state.noSearchDone}
                    handleClearPressed={this.handleClearPressed}
                    handleSortByTypeChange={this.handleSortByTypeChange}
                    sortByValue={this.state.sortByValue}
                  />
                </Col>
                <Col xs="9">
                  <Row>
                    <div>
                      <LoadingStatusModal
                        modal={this.state.modal}
                        toggle={this.toggle}
                        countText={this.state.countText}
                        currentpageLoaded={this.state.currentpageLoaded}
                        nrOfResultPages={this.state.nrOfResultPages}
                      />
                      <AboutModal
                        aboutmodal={this.state.aboutmodal}
                        abouttoggle={this.abouttoggle}
                      />
                    </div>
                  </Row>

                  {numberOfContractTypes == 0 && !this.state.noSearchDone ? (
                    <Row>
                      Please select a job type from the available checkboxes.
                    </Row>
                  ) : (
                    <Row>
                      {filteredJobs.map((item, index) => (
                        //{filtered.map((item, index) => (

                        <Col sm="4" key={item.id}>
                          <div className="post-module hover">
                            {/* -- Thumbnail --> */}

                            <div className="thumbnail">
                              <div className="date">
                                <div className="day">
                                  Posted <br />
                                  {this.compareDate(
                                    item.created.split("T", 1)
                                  )}{" "}
                                </div>
                                <div className="month" />
                              </div>
                              <div className="heart">
                                <a
                                  href="#"
                                  onClick={e =>
                                    this.addHeartClicked(e, item.id)
                                  }
                                >
                                  <img
                                    src={item.favAdded ? heart : heart_outline}
                                    alt="logo"
                                  />
                                </a>
                              </div>
                              <div className="main-job-title">
                                <a href={item.redirect_url} target="_blank">
                                  <p
                                    className="jobTitle"
                                    dangerouslySetInnerHTML={{
                                      __html: item.title
                                    }}
                                  />
                                </a>
                              </div>
                            </div>
                            {/* -- Post Content --> */}

                            <div className="post-content">
                              <div className="category">
                                {typeof item.contract_type == "undefined"
                                  ? "Undefined"
                                  : item.contract_type}
                              </div>
                              <h1 className="title">
                                £{Math.round(item.salary_max)}{" "}
                              </h1>
                              <h2 className="sub_title">
                                {item.location.display_name}
                              </h2>

                              <div
                                className="description"
                                dangerouslySetInnerHTML={{
                                  __html: item.description
                                }}
                              />

                              <div className="post-meta">
                                <span className="comments">
                                  <i className="fa fa-comments" />
                                  <a href="#">
                                    {" "}
                                    Posted By: {item.company.display_name}
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
